import { FC, Fragment } from "react";
import {
  createStyles,
  Grid,
  makeStyles,
  Typography,
  useMediaQuery,
} from "@material-ui/core";
import { uniq } from "lodash";
import pluralize from "pluralize";

import { EssentialImage } from "components";
import { IncludedRights } from "services/includedRights/types";
import { ListingRoyaltyPayor } from "services/listings/types";
import theme from "theme";

import ParagraphContent from "../ParagraphContent";
import RoyaltiesTable from "./RoyaltiesTable";

const useStyles = makeStyles(() =>
  createStyles({
    title: {
      fontWeight: theme.typography.fontWeightBold,
      fontSize: "1.625rem",
      marginBottom: theme.spacing(3),
    },
    includedRightsTableWrapper: {
      maxWidth: "670px",
      margin: "auto",
    },
  }),
);

export interface RoyaltiesProps {
  customIncludedRights: IncludedRights;
  royaltyPayors: ListingRoyaltyPayor[];
}

const Royalties: FC<RoyaltiesProps> = ({
  customIncludedRights,
  royaltyPayors,
}) => {
  const classes = useStyles();
  const isSmDown = useMediaQuery(theme.breakpoints.down("sm"));
  const royaltyPayorDescriptions = royaltyPayors
    .filter(royaltyPayor => !!royaltyPayor.description)
    .map(royaltyPayor => [royaltyPayor.display_name, royaltyPayor.description]);
  const royaltyPayorKinds = uniq(
    royaltyPayors.map(royaltyPayor => royaltyPayor.kind),
  );
  return (
    <>
      <Grid
        container
        spacing={isSmDown ? 2 : 8}
        justify={!!royaltyPayorDescriptions.length ? "flex-start" : "center"}
      >
        {(royaltyPayorKinds.length === 1 || customIncludedRights) && (
          <Grid
            item
            xs={12}
            md={!!royaltyPayorDescriptions.length ? 6 : 12}
            className={classes.includedRightsTableWrapper}
          >
            <RoyaltiesTable
              royaltyPayorKind={royaltyPayorKinds[0]}
              royaltyPayorNames={royaltyPayors.map(
                royaltyPayor => royaltyPayor.display_name,
              )}
              includedRights={customIncludedRights}
            />
          </Grid>
        )}
        {!!royaltyPayorDescriptions.length && (
          <Grid item xs={12} md={6}>
            <Typography className={classes.title}>
              About the Royalty{" "}
              {pluralize("Distributor", royaltyPayorDescriptions.length)}
            </Typography>
            <ParagraphContent>
              {royaltyPayorDescriptions.map(([name, description]) => (
                <Fragment key={name}>
                  <strong>{name}</strong>
                  <EssentialImage htmlString={description} />
                </Fragment>
              ))}
            </ParagraphContent>
          </Grid>
        )}
      </Grid>
    </>
  );
};

export default Royalties;
